import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './quoteFileRender.module.scss';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { ReactComponent as SquareQuoteIcon } from 'v2/icons/square-quote.svg';
import { openFile } from 'v2/utils/drmFileUtils';

type QuoteFileRenderProps = {
  href: string;
  children: React.ReactNode;
};

const QuoteFileRender = ({ href, children }: QuoteFileRenderProps) => {
  const match = href.match(/(?:\?|&)page=(\d+)/);
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip`} className={styles.tooltip}>
          <p className={classnames(styles.fileName)}>{children}</p>
          <span>{match ? ' pg ' + match[1] : ''}</span>
        </Tooltip>
      }
    >
      <Button
        variant="link"
        className={classnames('d-inline p-0', styles.buttonLink)}
        onClick={() => {
          openFile(href);
        }}
        data-testid="quotesButton"
      >
        <SquareQuoteIcon className={styles.quotes} />
      </Button>
    </OverlayTrigger>
  );
};

export default QuoteFileRender;
